import { IsEmail, IsNotEmpty } from "class-validator";

export class EmailChangeRequestDto {
  @IsNotEmpty()
  @IsEmail()
  new_email: string;
}

export class EmailChangeVerifyDto {
  @IsNotEmpty()
  verification_code: string;
}

